module.exports = __webpack_public_path__ + "static/img/8.966ff84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/8.png
// module id = Orzq
// module chunks = 0